import React, { useEffect, useState } from "react";
import ListLayout from "../../../../../partials/content/ListLayout";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import RecInvoiceBasicInfo from "./recInvoiceBasicInfo";
import { getRecInvoiceDetail } from "../../../../../services/finance/invoice";
import Notes from "../../../common/notes";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function RecInvoiceDetail({ match, history }) {
  const { reload } = useGlobalData();
  const invoiceID = match.params.invoiceID;
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [invoice, setInvoice] = useState(null);
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "invoices",
      label: "Invoices",
      icon: "fas fa-file-invoice-dollar",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getRecInvoiceData(invoiceID);
  }, [invoiceID, reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/invoices/AR",
            title: "Invoices",
            active: false,
          },
          {
            page: "/finance/invoice-detail/" + invoiceID,
            title: "Recurring Account Receivable ID " + invoiceID,
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/invoices/AR");
            },
          },
        ]}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = <RecInvoiceBasicInfo invoice={invoice} />;
                setHeaderTitle("Basic Info");
                break;
              case "payments":
                //selectedComponent = <InvoicePayments invoice={invoice} />;
                setHeaderTitle("Payments");
                break;
              case "notes":
                selectedComponent = <Notes docType="RNVO" docID={invoice.ID} />;
                setHeaderTitle("Notes");
                break;
              default:
                selectedComponent = <RecInvoiceBasicInfo invoice={invoice} />;
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getRecInvoiceData(invoiceID) {
    const response = await getRecInvoiceDetail(invoiceID);
    const { data } = response.data;
    const componentTmp = <RecInvoiceBasicInfo invoice={data.invoice} />;
    setInvoice(data.invoice);
    setComponent(componentTmp);
  }
}

export default RecInvoiceDetail;
